import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import ceoImg from '../assets/team/Alan_Karul_CEO.jpeg';
import headOfOpsImg from '../assets/team/Raymond_Mizrachi.jpeg';
import legalCounselImg from '../assets/team/Brian_Schechter_legal_counsel.jpeg';

const fadeUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6 } } };
const stagger = { visible: { transition: { staggerChildren: 0.15 } } };

const leadership = [
  {
    name: 'Alan Karul',
    role: 'Chief Executive Officer',
    quote: 'We focus on long-term partnerships and reliable access to capital.',
    img: ceoImg,
  },
  {
    name: 'Raymond Mizrachi',
    role: 'Chief of Operations',
    quote: 'We operate with speed, communication, and a focus on closing deals.',
    img: headOfOpsImg,
  },
  {
    name: 'Matthew Brennen',
    role: 'Chief Financial Officer',
    quote: 'We bring financial discipline and clarity to every funding decision.',
    img: null,
  },
  {
    name: 'Brian Schechter',
    role: 'Chief Legal Officer',
    quote: 'Clear structure and disciplined processes support every deal we fund.',
    img: legalCounselImg,
  },
];

export default function About() {
  return (
    <main className="bg-[#FCFCFD] text-gray-900">
      <HeroSection
        tag="ABOUT BIZFUND"
        title="Fast funding for businesses. A reliable partner for brokers."
        subtitle="Built by operators who understand the value of working capital and step in when banks won't. Fast decisions. Flexible funding. Real underwriting."
        image="/images/offline/photo-1600880292203-757bb62b4baf.jpg"
      />

      <section className="page-section border-b border-gray-100 bg-[#FCFCFD] pb-16 md:pb-20 lg:pb-24">
        <div className="page-container">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="section-intro-wide mx-auto max-w-3xl text-center"
          >
            <span className="text-xs uppercase tracking-widest text-amber-600 font-semibold">The Team</span>
            <h2 className="mt-3 text-4xl font-bold text-gray-900 md:text-5xl">Leadership</h2>
          </motion.div>

          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="mx-auto grid max-w-5xl gap-6 sm:grid-cols-2 lg:grid-cols-4"
          >
            {leadership.map((l) => (
              <motion.div
                key={l.name}
                variants={fadeUp}
                className="group flex h-full flex-col overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(15,23,42,0.10)]"
              >
                <div className="relative aspect-[3/4] overflow-hidden bg-slate-100">
                  {l.img ? (
                    <img
                      src={l.img}
                      alt={l.name}
                      className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.02]"
                    />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center bg-slate-900 text-3xl font-semibold tracking-[0.08em] text-white">
                      {l.name
                        .split(' ')
                        .map((part) => part[0])
                        .join('')
                        .slice(0, 2)}
                    </div>
                  )}
                </div>

                <div className="flex flex-1 flex-col justify-between border-t border-slate-100 px-5 py-5 text-center">
                  <div>
                    <h3 className="text-lg font-semibold tracking-tight text-slate-900">{l.name}</h3>

                    <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
                      {l.role}
                    </p>
                  </div>

                  <div className="mx-auto mt-5 h-px w-12 bg-amber-500/70" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
    </main>
  );
}
